exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sharepoint-wrapper[data-v-a923c6e4]{margin:1rem}.dropzone[data-v-a923c6e4]{position:relative;z-index:0;padding:.5rem;height:70px;border:1px dashed #a5a5a8;display:flex;justify-content:center;align-items:center}.dropzone p[data-v-a923c6e4]{text-align:center;font-size:1rem;color:#a5a5a8;margin:0;padding:0}.input-file[data-v-a923c6e4]{cursor:pointer}.input-file[data-v-a923c6e4],.input-file-disabled[data-v-a923c6e4]{opacity:0;width:100%;height:100%;position:absolute;z-index:9;margin:-7px}", ""]);

// exports
